<template>
  <div v-if="getProtocolCreateFlag == true" class="newProtocolWrap">
    <p v-if="noneSelectProtocol==false" class="txt">현재 장비에 프로토콜이 없습니다.</p>
    <p v-if="noneSelectProtocol" class="txt">좌측 이슈리스트에서 프로토콜을 선택해주세요.</p>
    
    <btn-link  v-if="noneSelectProtocol==false" classType="border-blue-plus" @click="cancelHandler">프로토콜 추가하기</btn-link>
  </div>
  <div v-else class="newProtocolWrapNoCreate">
    <p class="txt"><b>공정도에서 프로토콜을 생성하기 위해서는 재료, 목적, 장비가 모두 연결되어 있어야 됩니다.</b></p>
    <p class="txt"><font color="red">※ 프로토콜 작성 후 재료, 목적, 장비를 선택하시려면 게이트웨이로 이동 후 프로토콜을 생성해 주세요.</font></p>
  </div>
</template>

<script>
import BtnLink from '@components/btns/BtnLink.vue'; 
import CommNew from "@processEditor/CommNew";
export default {
  mixins:[ CommNew ] ,
  components : { 
    BtnLink , 
  } , 
  methods : {
    cancelHandler () {
      this.$emit( 'click' ) ; 
    } , 
  },
  watch : {
		'$route.query.protocolId' : {
			async handler () {
        if( this.$route.query.protocolId ){
          this.noneSelectProtocol = false;
        }
			} , 
		} , 
  },
  mounted() {
    if( !this.$route.query.protocolId ){
      this.noneSelectProtocol = true;
      this.status.issueListViewBln = true;
    }
  },
  data(){
    return {
      noneSelectProtocol:false,
    }
  }
}

</script>

<style lang="scss" scoped>
.newProtocolWrap {
  position: fixed; 
  display: flex; 
  flex-direction: column; 
  left: 50%; 
  top: 50%; 
  z-index: 98; 
  gap: var( --default-gap ); 
  align-items: center; 
  > .txt {
    font-size: 16px; 
    @include text-prt; 
  }
  &:hover {
    a {
      background-color: #1A4EDF; 
      color: $white; 
      &::before {
        filter: brightness(100); 
      }
    }
  }
}
.newProtocolWrapNoCreate {
  position: fixed; 
  display: flex; 
  flex-direction: column; 
  left: 40%; 
  top: 50%; 
  z-index: 98; 
  gap: var( --default-gap ); 
  align-items: center; 
  > .txt {
    font-size: 16px; 
    @include text-prt; 
  }
}
</style>